<template>
  <div class="tnbt">
    <h1>TNBT</h1>
    <Info :keyword="keyword" :page="page" :totalPage="totalPage"></Info>
    <Searcher @search="handleSearch" :showCategory="false"></Searcher>
    <Pager :page="page" :totalPage="totalPage" @changePage="handleChangePage"></Pager>
    <Btbody :docs="docs" :searchState="searchState"></Btbody>
    <Searcher @search="handleSearch" :showCategory="false"></Searcher>
    <Pager :page="page" :totalPage="totalPage" @changePage="handleChangePage"></Pager>
    <Info :keyword="keyword" :page="page" :totalPage="totalPage"></Info>
  </div>
</template>

<script>
import $ from "jquery/dist/jquery.min.js";
import Info from "./Info";
import Searcher from "./Searcher";
import Pager from "./Pager";
import Btbody from "./Btbody";
export default {
  name: "Tnbt",
  props: {
    urlBase: String,
    token: String
  },
  components: {
    Info,
    Searcher,
    Pager,
    Btbody
  },
  data: function() {
    return {
      count: 0,
      keyword: "",
      page: 1,
      countPerPage: 50,
      docs: [],
      countState: true,
      contentState: true
    };
  },
  computed: {
    url: function() {
      return this.urlBase + "/tnbt";
    },
    totalPage: function() {
      return Math.ceil(this.count / this.countPerPage);
    },
    countUrl: function() {
      return this.url + "/count";
    },
    searchState: function() {
      return this.countState && this.contentState;
    }
  },
  methods: {
    getCount() {
      this.countState = false;
      $.get(`${this.countUrl}?keyword=${this.keyword}`, { token: this.token })
        .then(result => {
          this.countState = true;
          if (result.success) {
            this.count = result.count;
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    getContent() {
      this.contentState = false;
      $.get(
        `${this.url}?keyword=${this.keyword}&page=${this.page}&countPerPage=${this.countPerPage}`,
        { token: this.token }
      )
        .then(result => {
          this.contentState = true;
          if (result.success) {
            this.docs = result.docs;
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    handleSearch(filter) {
      this.keyword = filter.keyword || "";
      this.page = 1;
      if (this.keyword.trim()) {
        this.getCount();
        this.getContent();
      }
      window.scrollTo(0, 0);
    },
    handleChangePage(p) {
      this.page = p;
      this.getContent();
      window.scrollTo(0, 0);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}
h1{
    text-align: center;
    font-family: cursive;
    text-shadow: #aaa 2px 2px 5px
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
